module.exports = __webpack_public_path__ + "img/217-Schoco SAF-RAL 9007 semigloss.png";